import { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";

import useAxios from "@src/config/axios/useAxios";
import { getCustomStudyDicomEndpoint } from "@src/config/baseUrls";

interface AddDicomFileModel {
  studyId: string;
  testId: string;
  file: File;
}

const useAddDicomToCustomTest = () => {
  const axios = useAxios();

  return useMutation<AxiosResponse, AxiosError, AddDicomFileModel>(
    "addDicomFile",
    (values: AddDicomFileModel) => {
      const formData = new FormData();
      formData.append("Guid", values.testId);
      formData.append("PhantomCode", "-1");
      formData.append("File", values.file);

      return axios.post(getCustomStudyDicomEndpoint(values.studyId), formData);
    },
  );
};

export default useAddDicomToCustomTest;
